
export const trigonometricFunctionNames = ["cos", "sin", "tg", "ctg"];
